.panel {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  background: var(--color-bg);

  transform: translateY(14px);
  opacity: 0;
  pointer-events: none;
  transition:
    transform 0.28s cubic-bezier(0.2, 0.8, 0.2, 1),
    opacity 0.22s ease;
}

.panel[data-open='true'] {
  transform: translateY(0);
  opacity: 1;
  pointer-events: auto;
}

@media (prefers-reduced-motion: reduce) {
  .panel {
    transition-duration: 0.01ms;
  }
}

.header {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 14px;
  flex: none;
  background: #1b1d2b;
  box-shadow: 0 1px 0 rgb(233 233 237 / 0.08);
}

.title {
  margin: 0;
  margin-right: auto;
  font-size: 15px;
  font-weight: 500;
}

/* — mobile — */

.mobileBody {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 13px 14px 30px;
}

.seg {
  width: 100%;
}

.seg > :global(.seg-opt) {
  flex: 1;
  justify-content: center;
  min-height: 44px;
}

.mobileActions {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mobileActions button {
  min-height: 46px;
  margin: 0;
}

/* — desktop — */

.columns {
  flex: 1;
  min-height: 0;
  display: flex;
  gap: 24px;
  padding: 24px;
  justify-content: center;
}

.column {
  flex: 1;
  max-width: 520px;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.tagRow {
  display: flex;
  align-items: baseline;
  gap: 8px;
}

/* — shared — */

.preview {
  flex: 1;
  min-height: 0;
  width: 100%;
  object-fit: contain;
  border-radius: 8px;
  box-shadow:
    0 0 0 1px var(--color-neutral-800),
    0 16px 40px rgb(0 0 0 / 0.65);
}

.caption {
  margin: 0;
  font-size: 12px;
  color: rgb(233 233 237 / 0.5);
}

@media (min-width: 900px) {
  .header {
    padding: 16px 24px;
  }

  .title {
    font-size: 17px;
  }
}
